'use strict';

export function UserResource($resource) {
  'ngInject';

  let User = $resource('/api/users/:id/:controller', {
    id: '@_id'
  }, {
    get: {
      method: 'GET',
      params: {
        id: 'me'
      }
    },
    update: {
      method: 'PUT',
    },
  });
  User.prototype.saveApplicationConfigs = function() {
    return User.update({id: this._id}, {applicationConfigs: this.applicationConfigs}).$promise
      .then((updated) => {
        console.log('saveAppConfig updated', updated);
      });
  };

  return User;
}
